import { EMIT, SYMBOL_LIVE_FEED_RESET } from '../../constants/ActionTypes';

// Common actions
export const subscribeSymbolLiveFeed =
  (symbols = []) =>
  (dispatch) => {
    if (!symbols.length) {
      return Promise.resolve();
    }

    dispatch({
      type: EMIT,
      payload: {
        method: 'subscribe_instrument_live_feed',
        data: {
          symbols,
        },
      },
    });

    return Promise.resolve();
  };

export const unsubscribeSymbolLiveFeed =
  (symbols = []) =>
  (dispatch) => {
    if (!symbols.length) {
      return Promise.resolve();
    }

    dispatch({
      type: EMIT,
      payload: {
        method: 'unsubscribe_instrument_live_feed',
        data: {
          symbols,
        },
      },
    });

    return Promise.resolve();
  };

export const resetSymbolLiveFeed = () => (dispatch) => {
  dispatch({
    type: SYMBOL_LIVE_FEED_RESET,
  });

  return Promise.resolve();
};
